import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const verifyEmailParamsSchema = z.object({
  session_token: z.string().catch(''),
  state: z.string().catch(''),
});

export const Route = createFileRoute('/verify-email')({
  validateSearch: (search) => verifyEmailParamsSchema.parse(search),
});
